const IssueDisplayer = {
    renderIssuesTable: (issueData, targetElement) => {
        // Clear previous content
        targetElement.innerHTML = '';

        if (issueData.Issues && Object.keys(issueData.Issues).length > 0) {
            const getPriority = (color) => {
                switch (color) {
                    case "Yellow": return "Medium";
                    case "Red": return "High";
                    case "Green": return "Low";
                    case "Blue": return "None";
                    default: return color;
                }
            };

            // Create table structure using DOM APIs
            const table = document.createElement('table');
            table.className = 'table w-full text-sm';

            const thead = document.createElement('thead');
            const headerRow = document.createElement('tr');
            const addHeaderCell = (text) => {
                const th = document.createElement('th');
                th.className = 'text-left py-2 px-4';
                th.textContent = text;
                headerRow.appendChild(th);
            };

            addHeaderCell('Image');
            addHeaderCell('Description');
            addHeaderCell('Assignment');
            addHeaderCell('Priority');
            addHeaderCell('Created');

            thead.appendChild(headerRow);
            table.appendChild(thead);

            const tbody = document.createElement('tbody');

            for (const issueId in issueData.Issues) {
                const issue = issueData.Issues[issueId];
                const tr = document.createElement('tr');

                // Image cell
                const imageTd = document.createElement('td');
                imageTd.className = 'py-2 px-4';

                if (issue.ViewPointImageDataBase64) {
                    // Build the thumbnail <img> via DOM APIs so all user data stays as text/attributes.
                    const img = document.createElement('img');
                    img.src = issue.ViewPointImageDataBase64;
                    img.setAttribute('data-role', 'issue-thumb');
                    img.setAttribute('data-full', issue.ViewPointImageDataBase64);

                    const desc = issue.Text || '';
                    const assignment = issue.Assignment || '';
                    const createdText = 'Created ' + Util.getFormattedUTCDateTimeForUI(new Date(issue.Created));

                    const priorityLabel = (function (color) {
                        switch (color) {
                            case 'Red': return 'High priority';
                            case 'Yellow': return 'Medium priority';
                            case 'Green': return 'Low priority';
                            case 'Blue': return 'None';
                            default: return '';
                        }
                    })(issue.Color);
                    const priorityColor = issue.Color || '';

                    img.setAttribute('data-desc', desc);
                    img.setAttribute('data-assignment', assignment);
                    img.setAttribute('data-priority', priorityLabel);
                    img.setAttribute('data-priority-color', priorityColor);
                    img.setAttribute('data-created', createdText);
                    img.alt = 'Viewpoint';
                    img.className = 'w-48 cursor-pointer';

                    imageTd.appendChild(img);
                }

                tr.appendChild(imageTd);

                const addTextCell = (text) => {
                    const td = document.createElement('td');
                    td.className = 'py-2 px-4';
                    td.textContent = text;
                    tr.appendChild(td);
                };

                addTextCell(issue.Text || '');
                addTextCell(issue.Assignment || '');
                addTextCell(getPriority(issue.Color));
                addTextCell(Util.getFormattedUTCDateTimeForUI(new Date(issue.Created)));

                tbody.appendChild(tr);
            }

            table.appendChild(tbody);
            targetElement.appendChild(table);
        } else {
            // Static HTML only; no user data involved here.
            targetElement.innerHTML = '<p>No issues found in this file.</p>';
        }
    },

    fetchAndDisplayIssues: async (groupInfo, targetElement, entryToShow, onError) => {
        targetElement.innerHTML = '<p>Loading issues...</p>';
        try {
            let issueEntry = null;
            let issueEntryHash = null;

            if (entryToShow) {
                issueEntry = entryToShow.entryValue;
                issueEntryHash = entryToShow.entryHash;
            } else {
                const indexRes = await Cloud.getIndexFromCloud(groupInfo);
                if (!indexRes.success) throw new Error("Could not retrieve file index.");

                for (const key in indexRes.indexFile.Entries) {
                    if (indexRes.indexFile.Entries[key].File?.ArkioIssues) {
                        issueEntry = indexRes.indexFile.Entries[key];
                        issueEntryHash = key;
                        break;
                    }
                }
            }

            if (!issueEntry) throw new Error("No issue file found.");

            const objectName = Cloud.getEntryObjectName(issueEntry, issueEntryHash);
			const encryptionKey = Cloud.getEntryObjectEncryptionKey(issueEntry, groupInfo.groupID);
			const nrOfParts = issueEntry.File.NrOfParts;

            const getRes = await Cloud.getCloudFileBytes(objectName, encryptionKey, nrOfParts, groupInfo.version);

            if (!getRes.success) throw new Error("Failed to download or decrypt issue content.");
            
            const decryptedBytes = getRes.decryptedBytes;
            const issueData = await DataUtil.processIssuesZip(decryptedBytes);

            IssueDisplayer.renderIssuesTable(issueData, targetElement);
            return { success: true, issueEntry: issueEntry, issueEntryHash: issueEntryHash, issueData: issueData };

        } catch (error) {
            console.error("Failed to fetch and display issues:", error);
            targetElement.innerHTML = '';
            if (onError) onError("Unable to load this issue.");
            return { success: false, error: error };
        }
    }
}; 